export const DATA_CY_GLOSSARY_LETTER_ITEM = 'glossary-letter-item';
export const DATA_CY_GLOSSARY_TERM_ITEM = 'glossary-term-item';
